
import { mapState, mapMutations } from "vuex";
import { LegalNotices } from "@/graphql/legal";

export default {
  nuxtI18n: {
    paths: {
      "en-ca": "/legal-notices",
      "fr-ca": "/mentions-legales",
    },
  },
  async asyncData({ app, i18n }) {
    const client = app.apolloProvider.defaultClient;
    const locale = i18n.locale.slice(0, 3) + i18n.locale.slice(3).toUpperCase();
    const legalResponse = await client.query({
      query: LegalNotices,
      variables: { locale: locale },
    });
    const mentionsLegale = legalResponse.data.mentionLegale.data.attributes;
    return { mentionsLegale };
  },
  data() {
    return {
      mentionsLegale: {},
      show: false,
    };
  },
  head() {
    return {
      title: this.mentionsLegale.SEO.MetaTitle,
      meta: [
        {
          hid: "description",
          name: "description",
          content: this.mentionsLegale.SEO.MetaDescription,
        },
        {
          hid: "og:description",
          name: "og:description",
          content: this.mentionsLegale.SEO.MetaDescription,
        },
      ],
    };
  },
  mounted() {
    setTimeout(() => this.setPageAnimation("animBanner"), 500);
  },
  computed: {
    ...mapState(["pageScroll"]),
  },
  methods: {
    ...mapMutations({
      setPageAnimation: "SET_PAGE_ANIMATION",
    }),
  },
  watch: {
    pageScroll: function () {
      //Ajouter - le height du Header fix apres le bottom
      let haveShow = false;
      if (
        this.$refs.animated?.getBoundingClientRect().bottom -
          window.innerHeight +
          90 <=
        0
      ) {
        this.show = true;
        haveShow = true;
      }
    },
  },
};
